import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EnvironmentService } from 'src/app/core/services/environment.service';

@Component({
  selector: 'app-application-files-info',
  templateUrl: './application-files-info.component.html',
  styleUrls: ['./application-files-info.component.scss']
})
export class ApplicationFilesInfoComponent implements OnInit {

  webRootPath: string = this.env.envVariables.webRootPath + `${this.data.applicationId}/${this.data.fileType.replace(" ", "")}/`;

  constructor(
    public dialog: MatDialogRef<ApplicationFilesInfoComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data : {applicationId: string, fileType: string},
    private env: EnvironmentService,
    private clipboard: Clipboard,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
  }

  onSubmit(){
    this.snackBar.open("Path Copied!", "Ok", {
      duration: 5000
    });
    this.clipboard.copy(this.webRootPath);
    this.dialog.close(true);
  }

  onClose(){
    this.dialog.close(false)
  }
}
